angular.module('unica_workshop_session.workshop_session_services')

.factory('WorkshopSessionListService', function ($http, getBaseApiURL) {

	var workshopSessionListService = {};

	workshopSessionListService.list = function (workshopId, limit, offset) {
		return $http({
			method: 'POST',
			url: getBaseApiURL + '/workshop-session/list/' + workshopId,
			data: {
				limit: limit,
				offset: offset,
			}
		}).then(function(result) {

			if ( result ) {
				return result.data.workshop_sessions;
			}

		});

	};

	workshopSessionListService.listByEvent = function (eventId) {
		return $http({
			method: 'POST',
			url: getBaseApiURL + '/workshop-session/list-by-event/' + eventId,
			data: { }
		}).then(function(result) {

			if ( result ) {
				return result.data.workshop_sessions;
			}

		});

	};

	workshopSessionListService.get = function (workshopId) {
		return $http({
			method: 'POST',
			url: getBaseApiURL + '/workshop-session/detail/' + workshopId,
			data: { }
		}).then(function(result) {

			if ( result ) {
				return result.data.workshop_session;
			}

		});

	};


	return workshopSessionListService;
});